// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Piccer_container__DZ-M6 {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Piccer_container__DZ-M6 .Piccer_picture__Mrulq {
  width: calc(100vw - 800px);
  height: calc(100vh - 200px);
  display: flex;
  background: white;
  position: relative;
}
.Piccer_container__DZ-M6 .Piccer_picture__Mrulq img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.Piccer_container__DZ-M6 .Piccer_panel__zktjD {
  background: white;
  height: calc(100vh - 200px);
  width: 300px;
  border-left: 1px solid #23AFD8;
  position: relative;
}
.Piccer_container__DZ-M6 .Piccer_panel__zktjD ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  width: 100%;
}
.Piccer_container__DZ-M6 .Piccer_panel__zktjD ul li {
  border-left: 1px solid #23AFD8;
  border-bottom: 1px solid #23AFD8;
  flex: 1 1;
  text-align: center;
  color: #23AFD8;
  padding: 10px;
  cursor: pointer;
}
.Piccer_container__DZ-M6 .Piccer_panel__zktjD ul li.Piccer_active__U4uCg {
  background: #23AFD8;
  color: white;
}
.Piccer_container__DZ-M6 .Piccer_panel__zktjD ul li:first-child {
  border-left: 0;
}

.Piccer_tabContent__JMhX9 {
  padding: 20px;
  text-align: center;
  position: relative;
  height: calc(100% - 42px);
}
.Piccer_tabContent__JMhX9 .Piccer_footer__1AJoG {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
}
.Piccer_tabContent__JMhX9 .Piccer_footer__1AJoG span.Piccer_btn__DW7lM {
  background: #23AFD8;
  color: white;
  text-align: center;
  padding: 20px;
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
  flex: 1 1;
}
.Piccer_tabContent__JMhX9 .Piccer_footer__1AJoG span.Piccer_btnCancel__6YKt7 {
  background: #F8546F;
  color: white;
  text-align: center;
  padding: 20px;
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
  flex: 1 1;
}

.Piccer_formGroup__jThhK {
  margin-bottom: 20px;
}
.Piccer_formGroup__jThhK label {
  font-weight: bold;
  display: block;
  text-align: left;
  margin-bottom: 5px;
}
.Piccer_formGroup__jThhK input[type=range] {
  width: 100%;
}
.Piccer_formGroup__jThhK select {
  width: 100%;
  height: 30px;
}
.Piccer_formGroup__jThhK .Piccer_doubleInput__bdx0m {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.Piccer_formGroup__jThhK .Piccer_doubleInput__bdx0m input[type=text] {
  width: 100px;
  text-align: center;
}
.Piccer_formGroup__jThhK .Piccer_doubleInput__bdx0m span {
  font-size: 20px;
}

.Piccer_successBtn__Yj6Vw {
  background: #23AFD8;
  color: white;
  text-align: center;
  padding: 20px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  position: absolute;
  bottom: 0;
}

.Piccer_urlLink__mV8NE {
  border: 1px solid var(--bs-border-color);
  height: 30px;
  margin: 0 0 0 10px;
  max-width: 300px;
}

.Piccer_linkCopy__Pzi9T {
  display: flex;
  flex: 1 1;
  align-items: center;
  justify-content: flex-end;
}

.Piccer_urlButton__8RtBG {
  border: none;
  height: 30px;
}

.Piccer_uploadControl__NMKcs {
  display: flex;
  justify-content: space-between;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Piccer/Piccer.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,0BAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AACN;AAGE;EACE,iBAAA;EACA,2BAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;AADJ;AAGI;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;AADN;AAGM;EACE,8BAAA;EACA,gCAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AADR;AAGQ;EACE,mBAAA;EACA,YAAA;AADV;AAIQ;EACE,cAAA;AAFV;;AASA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AANF;AAQE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;AANJ;AAQI;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,SAAA;AANN;AASI;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,SAAA;AAPN;;AAYA;EACE,mBAAA;AATF;AAWE;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AATJ;AAYE;EACE,WAAA;AAVJ;AAaE;EACE,WAAA;EACA,YAAA;AAXJ;AAcE;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;AAZJ;AAcI;EACE,YAAA;EACA,kBAAA;AAZN;AAeI;EACE,eAAA;AAbN;;AAkBA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AAfF;;AAkBA;EACE,wCAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;AAfF;;AAkBA;EACE,YAAA;EACA,YAAA;AAfF;;AAkBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAfF","sourcesContent":[".container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0, 0, 0, .5);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .picture {\n    width: calc(100vw - 800px);\n    height: calc(100vh - 200px);\n    display: flex;\n    background: white;\n    position: relative;\n\n    img {\n      max-width: 100%;\n      max-height: 100%;\n      object-fit: contain;\n    }\n  }\n\n  .panel {\n    background: white;\n    height: calc(100vh - 200px);\n    width: 300px;\n    border-left: 1px solid #23AFD8;\n    position: relative;\n\n    ul {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      display: flex;\n      width: 100%;\n\n      li {\n        border-left: 1px solid #23AFD8;\n        border-bottom: 1px solid #23AFD8;\n        flex: 1;\n        text-align: center;\n        color: #23AFD8;\n        padding: 10px;\n        cursor: pointer;\n\n        &.active {\n          background: #23AFD8;\n          color: white;\n        }\n\n        &:first-child {\n          border-left: 0;\n        }\n      }\n    }\n  }\n}\n\n.tabContent {\n  padding: 20px;\n  text-align: center;\n  position: relative;\n  height: calc(100% - 42px);\n\n  .footer {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n\n    span.btn {\n      background: #23AFD8;\n      color: white;\n      text-align: center;\n      padding: 20px;\n      font-weight: bold;\n      font-size: 12px;\n      cursor: pointer;\n      flex: 1;\n    }\n\n    span.btnCancel {\n      background: #F8546F;\n      color: white;\n      text-align: center;\n      padding: 20px;\n      font-weight: bold;\n      font-size: 12px;\n      cursor: pointer;\n      flex: 1;\n    }\n  }\n}\n\n.formGroup {\n  margin-bottom: 20px;\n\n  label {\n    font-weight: bold;\n    display: block;\n    text-align: left;\n    margin-bottom: 5px;\n  }\n\n  input[type='range'] {\n    width: 100%;\n  }\n\n  select {\n    width: 100%;\n    height: 30px;\n  }\n\n  .doubleInput {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n\n    input[type='text'] {\n      width: 100px;\n      text-align: center;\n    }\n\n    span {\n      font-size: 20px;\n    }\n  }\n}\n\n.successBtn {\n  background: #23AFD8;\n  color: white;\n  text-align: center;\n  padding: 20px;\n  font-weight: bold;\n  font-size: 16px;\n  cursor: pointer;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n}\n\n.urlLink {\n  border: 1px solid var(--bs-border-color);\n  height: 30px;\n  margin: 0 0 0 10px;\n  max-width: 300px;\n}\n\n.linkCopy {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.urlButton {\n  border: none;\n  height: 30px;\n}\n\n.uploadControl {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Piccer_container__DZ-M6`,
	"picture": `Piccer_picture__Mrulq`,
	"panel": `Piccer_panel__zktjD`,
	"active": `Piccer_active__U4uCg`,
	"tabContent": `Piccer_tabContent__JMhX9`,
	"footer": `Piccer_footer__1AJoG`,
	"btn": `Piccer_btn__DW7lM`,
	"btnCancel": `Piccer_btnCancel__6YKt7`,
	"formGroup": `Piccer_formGroup__jThhK`,
	"doubleInput": `Piccer_doubleInput__bdx0m`,
	"successBtn": `Piccer_successBtn__Yj6Vw`,
	"urlLink": `Piccer_urlLink__mV8NE`,
	"linkCopy": `Piccer_linkCopy__Pzi9T`,
	"urlButton": `Piccer_urlButton__8RtBG`,
	"uploadControl": `Piccer_uploadControl__NMKcs`
};
export default ___CSS_LOADER_EXPORT___;
